import { Typography } from 'antd'
import { WrapperProps } from './types'

/**
 * @example
 * No Recipients have been configured to receive an email for {children} Construction & Admin Submittal
 * No Recipients have been configured to receive an email for {children} of the Construction & Admin Submittal
 */
const Wrapper: React.FC<WrapperProps> = ({ children, ofThe }) => {
  return (
    <Typography.Text>
      No Recipients have been configured to receive an email for {children}
      {ofThe === false ? '' : ' of the'} Construction & Admin Submittal
    </Typography.Text>
  )
}

export default Wrapper
